interface SerieAgg {
  quantidade: number
  valor: number
}

interface Parcela {
  valor: number
}

interface GrupoParcelas {
  parcelas: Parcela[]
}

export class AgregadorParcelas {
  private readonly aggregatedEntradas: SerieAgg[] = []
  private readonly aggregatedMensais: SerieAgg[] = []
  private readonly aggregatedIntermediarias: SerieAgg[] = []
  private readonly aggregatedPosConclusao: SerieAgg[] = []
  private readonly aggregatedIntermediariasPosConclusao: SerieAgg[] = []

  agregarEntradas = (entradas: Parcela[]): this => {
    entradas.forEach((entrada) => {
      this.addToAgg(this.aggregatedEntradas, entrada.valor)
    })
    return this
  }

  agregarMensais = (mensais: GrupoParcelas[]): this => {
    const parcelasMensais = mensais.flatMap((m) => m.parcelas)
    parcelasMensais.forEach((parcela) => {
      this.addToAgg(this.aggregatedMensais, parcela.valor)
    })
    return this
  }

  agregarIntermediarias = (intermediarias: GrupoParcelas[]): this => {
    const parcelasIntermediarias = intermediarias.flatMap((i) => i.parcelas)
    parcelasIntermediarias.forEach((parcela) => {
      this.addToAgg(this.aggregatedIntermediarias, parcela.valor)
    })
    return this
  }

  agregarIntermediariasPosConclusao = (intermediarias: GrupoParcelas[]): this => {
    const parcelas = intermediarias.flatMap((i) => i.parcelas)
    parcelas.forEach((parcela) => {
      this.addToAgg(this.aggregatedIntermediariasPosConclusao, parcela.valor)
    })
    return this
  }

  agregarPosConclusao = (posConclusao: Parcela[]): this => {
    posConclusao.forEach((parcela) => {
      this.addToAgg(this.aggregatedPosConclusao, parcela.valor)
    })
    return this
  }

  getEntradas = (): string[] => {
    return this.formatSeries(this.aggregatedEntradas)
  }

  getMensais = (): string[] => {
    return this.formatSeries(this.aggregatedMensais)
  }

  getIntermediarias = (): string[] => {
    return this.formatSeries(this.aggregatedIntermediarias)
  }

  getPosConclusao = (): string[] => {
    return this.formatSeries(this.aggregatedPosConclusao)
  }

  getIntermediariasPosConclusao = (): string[] => {
    return this.formatSeries(this.aggregatedIntermediariasPosConclusao)
  }

  private readonly addToAgg = (agg: SerieAgg[], valor: number): void => {
    const linha = agg.find((l) => l.valor === valor)
    if (linha) {
      linha.quantidade += 1
      return
    }
    agg.push({ quantidade: 1, valor })
  }

  private readonly formatSeries = (agg: SerieAgg[]): string[] => {
    if (!agg.length) return ['R$ 0,00']
    return agg.map((l) => `${l.quantidade}x ${this.formatMoney(l.valor)}`)
  }

  private readonly formatMoney = (n: number): string => {
    return `R$ ${n.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`
  }
}
